import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AreaService } from '../../../services/area.service';
import { ModalImagenService } from '../../../services/modal-imagen.service';
import { BusquedasService } from 'src/app/services/busquedas.service';

import { AreaModel } from '../../../models/area.model';
import { SubAreaService } from '../../../services/subarea.service';
import { SubAreaModel } from '../../../models/subarea.model';

@Component({
    selector: 'app-areas',
    templateUrl: './areas.component.html',
    styleUrls: ['./areas.component.css'],
    standalone: false
})
export class AreasComponent implements OnInit, OnDestroy {


public area: AreaModel;
public areas: AreaModel[] = [];
public areasTemp: AreaModel[] = [];
public cargando: boolean = true;

private imgSubs: Subscription;

page = 1;
pageSize = 10;
collectionSize = 0;
maxSize = 0;

subAreas: SubAreaModel[] = [];
listaSelectSubAreas = [];


  constructor( private areasService: AreaService,
               private subareasService: SubAreaService,
               private modalImagenService: ModalImagenService,
               private busquedasService: BusquedasService ) { }


  ngOnDestroy(): void {
    this.imgSubs.unsubscribe();
  }

  ngOnInit(): void {
    this.cargarAreas();
    this.cargarSubAreas();

    this.imgSubs = this.modalImagenService.nuevaImagen
                        .pipe(delay(100))
                        .subscribe( img => this.cargarAreas() );



  }



cargarAreas() {

  this.cargando = true;
  this.areasService.cargarAreas()
                      .subscribe( areas => {
                        this.cargando = false;
                        this.areas = areas;
                        this.areasTemp = areas;
                        this.maxSize = Math.ceil(this.areasTemp.length / this.pageSize);
                        this.collectionSize = this.areasTemp.length;

                      });


}


cargarSubAreas() {

  this.subareasService.cargarSubAreas()
                      .subscribe( subareas => {

                        subareas.forEach( item =>{
                          this.subAreas.push(item);

                        });

                        if (subareas.length === 0) {
                          this.subAreas.push({
                            name: 'No Records Found',
                             _id: 'Default'});
                        }


                        this.listaSelectSubAreas = this.crearArray(this.subAreas);




                      });

}


guardarCambios( area: AreaModel ) {

  if(area.subareas.length > 1){
    area.subareas = [];
  }

  this.areasService.actualizarArea( area._id, area )
                      .subscribe( resp => {

                        this.cargarAreas();
                        Swal.fire(
                          'Updated',
                          area.name,
                          'success'
                        );
                      }, err => {
                        console.log('HTTP Error', err.error);
                        Swal.fire({
                         title: '¡Error!',
                         text: JSON.stringify(err.error.errors.name.msg),
                         icon: 'error',
                         confirmButtonText: 'Cerrar',
                         scrollbarPadding: false,
                         allowOutsideClick: false
                       });
                     });

}




buscar( termino: string ) {

  if ( termino.length === 0 ){
    return this.areas = this.areasTemp;
  }




  this.busquedasService.buscar( 'areas', termino )
                      .subscribe( (resp: any) => {
                        this.areas = resp;
                      });

}




borrarArea( area: AreaModel ) {

  this.areasService.borrarArea( area._id )
                      .subscribe( resp => {
                        this.cargarAreas();
                        Swal.fire(
                          'Deleted',
                          area.name,
                          'success'
                        );
                      });

}


borrarSubArea( area: AreaModel, subarea: SubAreaModel ) {
  const isIndexNumber = (element: SubAreaModel) => element === subarea;
  const index = area.subareas.findIndex(isIndexNumber);
  area.subareas.splice(index, 1);


  this.areasService.eliminaSubArea( area._id, area)
                      .subscribe( resp => {

                        this.cargarAreas();

                        Swal.fire(
                          'SubArea Deleted',
                          area.name,
                          'success'
                        );
                      }, err => {
                        console.log('HTTP Error', err.error);
                        Swal.fire({
                         title: '¡Error!',
                         text: JSON.stringify(err.error.errors.name.msg),
                         icon: 'error',
                         confirmButtonText: 'Cerrar',
                         scrollbarPadding: false,
                         allowOutsideClick: false
                       });
                     });





}


async abrirSweetAlert() {

  const { value = '' } = await Swal.fire<string>({
    title: 'New Area',
    text: 'Area Name',
    input: 'text',
    inputPlaceholder: 'Name',
    showCancelButton: true
  });


  if ( value.trim().length > 0 ) {

    this.areasService.crearArea( value )
                        .subscribe( (resp: any) => {

                          this.areas.push(resp.area);
                        }, (err) => {
                          console.warn( err.error );
                          Swal.fire('Error', err.error.msg, 'error');
                        });

    }

}



abrirModal( area: AreaModel) {
this.modalImagenService.abrirModal( 'areas', area._id, area.img );
}



refresData() {
  this.areas = this.areasTemp.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
}

 crearArray( ObjArray: object) {
  const arreglo: any[] = [];
  if ( ObjArray === null ) { return []; }

  Object.keys( ObjArray ).forEach( key => {

                  const item = ObjArray[key];
                  arreglo.push(item.name);

  });

  return arreglo;
}


async editarArea(_area) {
  this.area = _area;
  const isIndexNumber = (element: string) => element === _area.name;
  const { value: formValues = [] } = await Swal.fire<string[]>({
    inputOptions: this.listaSelectSubAreas,
    inputPlaceholder: 'Select SubArea',
    html: `
    <h3>Edit Area</h3>
    <hr class="mb-2">
    <div class="form-row">
    <div class="col-md-12 mb-3">
        <label>Name Area</label>
        <input type="text" class="form-control" id="area" value="${_area.name}" tabindex="-1">
    </div>
    </div>
    `,
    width: 600,
    showCancelButton: true,
    confirmButtonText:
    '<i class="fa fa-save"></i> Update',
    cancelButtonText:
    'Close',
    scrollbarPadding: false,
    allowOutsideClick: false,


    preConfirm: () => {

     return [

        Swal.getInput().value,
       (document.getElementById('area') as HTMLInputElement).value

      ];

  }
});




  if (formValues.length > 0) {


     const inputVacio = formValues.find(item => item === '') === '' ? true : false;

     if (inputVacio) {
      Swal.fire({
        html: `
        <div class="alert alert-warning" role="alert">
        <strong>¡Error! </strong>Falta Ingresar Datos
        </div>
        `,
        icon: 'error',
        scrollbarPadding: false,
        allowOutsideClick: false
      });
      return;
     }


     const areaNew = {
      ...this.area,
      nombre:  formValues[1],
      subareas:[ this.subAreas[formValues[0]]]
    };

    this.guardarCambios(areaNew);
}

}

}
